import React, { Component } from 'react';
import { styleMerge } from '../../utils/utils';

class CBButtonWithIconSmall extends Component {
  onKeyUp = event => {
    const { onClick } = this.props;
    event.preventDefault();
    if (event.keyCode === 13) {
      onClick();
    }
  };

  render() {
    const {
      onClick,
      text,
      icon,
      disabled,
    } = this.props;

    const disabledStyle = { opacity: 0.6, cursor: 'auto' };

    return (
      <div
        style={styleMerge(styles.container, disabled ? disabledStyle : {})}
        className={disabled ? '' : 'opacity-and-border-on-hover'}
        onClick={disabled ? () => {} : onClick}
        role='button'
        tabIndex={0}
        onKeyUp={this.onKeyUp}
      >
        {
          icon && (
            <img src={icon} alt={text} style={styles.icon} />
          )
        }
        <p style={icon ? styles.label : styles.labelNoIcon}>{text}</p>
      </div>
    );
  }
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid rgba(255,255,255,.3)',
    borderRadius: 50,
    paddingLeft: 10,
    paddingRight: 10,
    height: 30,
    marginRight: 10,
    cursor: 'pointer',
  },
  icon: {
    height: 24,
    width: 24,
  },
  label: {
    fontSize: 14,
    margin: 0,
    marginLeft: 10,
  },
  labelNoIcon: {
    fontSize: 14,
    margin: 0,
  },
};

export default CBButtonWithIconSmall;
